import styled from 'styled-components'

import { Box } from '../Box'
import { Image } from '../Image'

const BrandImage = styled(Image)`
  display: block;
  max-width: 110%;
`

const BrandBoxContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;

  height: 128px;
  width: 128px;

  background: ${({ theme }) => theme.colors.bgPrimary};
  clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);
  padding: ${({ theme }) => theme.space[4]};
`

export interface BrandBoxProps {
  image: string
}

export const BrandBox = ({ image }: BrandBoxProps) => {
  return (
    <BrandBoxContainer>
      <BrandImage src={image} />
    </BrandBoxContainer>
  )
}
